import MuiPreloader from './MuiPreloader';

export default MuiPreloader;
